import React from 'react';

const ChemicalIcon = ({
  color = '#FFFFFF'
}) => {
  return (
    <svg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.874 51.626C14.868 51.626 10 56.495 10 62.5c0 6.007 4.868 10.876 10.874 10.876S31.75 68.505 31.75 62.5c0-6.005-4.87-10.874-10.876-10.874zm66.376 37.25c-6.006 0-10.875 4.868-10.875 10.874 0 6.007 4.87 10.876 10.875 10.876 6.006 0 10.875-4.87 10.875-10.876 0-6.005-4.87-10.874-10.875-10.874zM93 39.75c6.006 0 10.875-4.87 10.875-10.875C103.875 22.87 99.005 18 93 18c-6.006 0-10.875 4.87-10.875 10.875 0 6.006 4.87 10.875 10.875 10.875zM42.5 29.5c0-2.898-2.35-5.25-5.25-5.25S32 26.602 32 29.5c0 2.9 2.35 5.25 5.25 5.25s5.25-2.35 5.25-5.25zm60 33c-2.9 0-5.25 2.35-5.25 5.25S99.6 73 102.5 73s5.25-2.35 5.25-5.25-2.35-5.25-5.25-5.25zm-58 32c-2.9 0-5.25 2.352-5.25 5.25 0 2.9 2.35 5.25 5.25 5.25s5.25-2.35 5.25-5.25c0-2.898-2.35-5.25-5.25-5.25zm42.75-32c0-12.565-10.186-22.75-22.75-22.75S41.75 49.936 41.75 62.5c0 12.564 10.186 22.75 22.75 22.75S87.25 75.065 87.25 62.5zm-40.376 0c0-9.733 7.892-17.626 17.626-17.626 9.734 0 17.625 7.892 17.625 17.627 0 9.734-7.89 17.626-17.625 17.626-9.734 0-17.626-7.892-17.626-17.626z'
        fill={color} fillRule='evenodd'
      />
    </svg>
  );
};

export default ChemicalIcon;



// WEBPACK FOOTER //
// ./src/app/components/atoms/icons/ChemicalIcon/ChemicalIcon.js